<template>
  <div>
    <app-nav></app-nav>
    <div class="container-fluid">
        <div class="col-xs-2 col-sm-1"></div>
        <div class="col-xs-10 col-sm-10">
            <div class="row">
                <h4 class="text-left" >Intérim IADE</h4>
                <br>
            </div>
            <div class="row col-5">
            <p>Le contrat (pdf) doit etre imprimé en 2 ex., signé et archivé.</p>
            <p>Le fichier pdae**.txt doit etre "uploadé" à: 
              <a 
              href="https://www.due.urssaf.fr/declarant/upload.jsf"
              target= "_blank">www.due.urssaf.fr/declarant/upload.jsf</a>
            </p>
            <p>
              Sans le fichier pdae.txt (il faut avoir un compte avec mot de passe etc), on peut valider simplement l'embauche en se connectant sur 
              <a 
              href="https://www.due.urssaf.fr"
              target= "_blank">www.due.urssaf.fr</a>
               et rentrer le numéro SIRET de la sdf: 48887447000021,
              puis répondre aux questions (1 minute).
            </p>
            </div>
            <div class="row my-4">
                <router-link class="btn btn-primary pull-left " :to="{name: 'ContratsInterimNew'} ">Nouveau contrat </router-link>   
            </div>
                <ul  v-if="pageCount > 1" class="pagination pagination-sm no-margin pull-right justify-content-center">
                    <li class="page-item"  v-if="showFirstPageIndex"><a class="page-link" href="#" @click="pageClicked(1)">1</a></li>
                    <li class="page-item"  v-if="showLessDots"><a class="page-link" href="#" @click="currentPage = startPaginatorIndex - 1">...</a></li>
                    <li class="page-item" v-for="n in pageRange" :key="n" :class="{active : n == currentPage}"><a class="page-link"  href="#" @click="pageClicked(n)">{{n}}</a></li>
                    <li class="page-item"  v-if="showMoreDots"><a class="page-link" href="#" @click="currentPage = endPaginatorIndex + 1">...</a></li>
                    <li class="page-item"  v-if="showLastPageIndex" @click="pageClicked(pageCount)"><a class="page-link" href="#">{{this.pageCount}}</a></li>
                </ul>
                    <div class="table-responsive row voffset5">
                    <table class="table table-striped">
                        <thead>
                        <tr>        
                            <th>#</th>
                            <th>Intérimaire</th>
                            <th>Dates</th>               
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="contrat in allContratsInterims.edges" :key="contrat.node.id">          
                            <th scope="row">{{ contrat.node.id }}</th>
                            <td class="text-left">{{ contrat.node.interimaireByInterimaireId.nom }}</td>
                            <td class="text-left"> {{nicelyFormatedDates(contrat.node.dateDebut, contrat.node.dateFin)}}</td>
                            <td><router-link class='btn btn-primary pull-right' :to="{name: 'ContratsInterimEdit', params: { id: contrat.node.id}}">Editer</router-link> </td>
                            <td><button  class='btn btn-primary pull-right' @click="renderPDF(contrat.node)">Imprimer Contrat</button></td>
                            <td><button  class='btn btn-primary pull-right' @click="generateDocuments(contrat.node)">Générer PDAE</button></td>
                            <td><button class='btn btn-danger pull-right' @click="deleteContrat(contrat.node.id)">Suppr.</button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AppNav from '../AppNav'

import { range } from 'lodash'
import { format } from 'date-fns'
import { CONTRATS_PER_PAGE } from '../../constants/settings'


var ContratInterim = require('../../assets/javascripts/ContratInterim')
var DPAE = require('../../assets/javascripts/dpae')

import {
  ALL_CONTRATS,
  DELETE_CONTRAT
} from '../../constants/contratsInterim'

const pageSize = 10

export default {
  name: 'contrats_interim',
  components: {
    AppNav
  },
  data() {
    return {
      allContratsInterims: {},
      contratsPerPage: CONTRATS_PER_PAGE,
      offset: 0,
      first: CONTRATS_PER_PAGE,
      currentPage: 1
    }
  },
  apollo: {
    allContratsInterims: {
      query: ALL_CONTRATS,
      variables() {
        var  offset =  this.offset
        var   first =   this.first
        return {
            offset,
            first
        }
      }
    }
  },

  computed: {

    pageCount(){
      return Math.ceil(this.allContratsInterims.totalCount/CONTRATS_PER_PAGE)
    },

    startPaginatorIndex() {
    // plus 1 so we get 1, 11, 21...
    let startIndex = (Math.floor(this.currentPage / 10) * 10) + 1
    // startIndex can be greater than the currentPage if the currentPage is divisible by 10
    if (startIndex > this.currentPage) {
        startIndex = (Math.floor((this.currentPage - 1) / 10) * 10) + 1
    }
    return startIndex;
    },

    endPaginatorIndex() {
      let endIndex = (Math.ceil(this.currentPage / 10) * 10)
      // when endIndex is greater than the pageCount we're at the end of our range
      if (endIndex > this.pageCount) {
        endIndex = this.pageCount
      }
      return endIndex;
    },

    showLessDots() {
    if (this.currentPage > 10) {
        return true;
    }
    return false;
    },

    showMoreDots() {
    if (this.pageCount > 11 && (this.endPaginatorIndex !== this.pageCount)) {
        return true
      }
    return false
    },

    showFirstPageIndex() {
      if (this.currentPage > 10) {
        return true
      }
      return false
    },

    showLastPageIndex() {
    if (this.pageCount > 10 && (this.endPaginatorIndex !== this.pageCount)) {
        return true
    }
      return false
    },

    pageRange() {
      return range(this.startPaginatorIndex, (this.endPaginatorIndex + 1))
    }
  },
  methods: {
    nicelyFormatedDates: function (dateD, dateF) {
      return `${format(new Date(dateD), 'dd/MM/yyyy')}-${format(new Date(dateD), 'HH')}h. au ${format(new Date(dateF),'dd/MM/yyyy')}-${format(new Date(dateF), 'HH')}h`
    },
    pageClicked: function(numPage){
        this.offset = this.contratsPerPage*(numPage -1)
        this.currentPage = numPage
    },
    generateDocuments: function (contrat) {
      DPAE.generateDPAE(contrat)
    },
    
    renderPDF: function (contrat) {      
      console.log('contrat', contrat)
      var docDefinition = {
        pageSize: 'A4',
        footer: function (currentPage, pageCount) { 
          return {
            margin:10,
            columns: [
              {
                fontSize: 9,
                text:[
                {
                text: '--------------------------------------------------------------------------' +
                '\n',
                margin: [0, 20]
                },
                {
                text: currentPage.toString(),
                }
                ],
                alignment: 'center'
              }
            ]
          }
        },
        content: ContratInterim.renderContratInterim(contrat),
        defaultStyle: {
          font: 'Lato',
          fontSize: 10
        }
      }
    this.$pdfmake.createPdf(docDefinition).download('contrat_interim.pdf')
  },
    deleteContrat(id){
      this.$apollo.mutate({
      mutation: DELETE_CONTRAT,
      variables: {
        id: id
      },
      refetchQueries: [{
        query: ALL_CONTRATS,
        variables: {
          offset: this.offset,
          first: this.first
          }
        }]           
      }).then((data) =>{

      }).catch((error) => {
      // Error
      console.error(error)
    })
    }
  }
}
</script>
<style scoped>
/* Move down content because we have a fixed navbar that is 3.5rem tall */
body {
    padding-top: 3.5rem;
}

h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
}

.sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
}

/* Sidebar navigation */

.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item+.nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}

.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

select option[data-default] {
    display: none;
}
.medecins-form{
    padding-bottom: 60px;
}
.modal-content {
    width: 635px;
}
</style>



// WEBPACK FOOTER //
// contrats.vue?381eefa0